export default __webpack_public_path__ + "static/media/ic_settings.47afa4c7.svg";